import { AbstractParser } from "../../parser";
import { Injectable } from "@angular/core";
import { ImportBeneficiaryResult } from "../../../../models/domains/pbm/Beneficiary/import-beneficiary-result";

@Injectable()
export class ImportFileParser extends AbstractParser<ImportBeneficiaryResult> {
  parse(payload: any): ImportBeneficiaryResult {
    if (payload.error) {
      return new ImportBeneficiaryResult(payload.error)
    }
    return new ImportBeneficiaryResult([])

  }
}
